import constructOptimisedImageUrl from "./imageOptimisation/constructOptimisedImageUrl";

type MaybeImageObject = {
  key?: string;
  url?: string;
  [key: string]: any;
} | string | null | undefined;

/**
 * Resolves a listing image entry (various shapes) into a usable src URL.
 * - Accepts: JSON string with key/url, raw key string, full URL string, object with key/url
 * - Returns: full URL (optimized when using key)
 */
export function resolveListingImageSrc(image: MaybeImageObject, size: number = 500): string {
  if (!image) return "";

  // Object with url/key
  if (typeof image === "object") {
    const asObj = image as Record<string, any>;
    if (asObj.url && typeof asObj.url === "string") return asObj.url;
    if (asObj.key && typeof asObj.key === "string") return constructOptimisedImageUrl(asObj.key, size);
    return "";
  }

  // String input
  if (typeof image === "string") {
    const str = image.trim();
    if (!str) return "";
    // Direct URL
    if (str.startsWith("http://") || str.startsWith("https://")) return str;
    // Try JSON
    try {
      const parsed = JSON.parse(str);
      if (parsed && typeof parsed === "object") {
        if (parsed.url && typeof parsed.url === "string") return parsed.url;
        if (parsed.key && typeof parsed.key === "string") return constructOptimisedImageUrl(parsed.key, size);
      }
    } catch {
      // Not JSON; treat as key
      return constructOptimisedImageUrl(str, size);
    }
  }

  return "";
}


